import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexTooltip',
  setup(__props) {

const basicTooltip = defineAsyncComponent(() => import("@/components/theme/uikits/tooltip/basicTooltip.vue"))
const coloredTooltip = defineAsyncComponent(() => import("@/components/theme/uikits/tooltip/coloredTooltip.vue"))
const directionsTooltip = defineAsyncComponent(() => import("@/components/theme/uikits/tooltip/directionsTooltip.vue"))
const hoverEffect = defineAsyncComponent(() => import("@/components/theme/uikits/tooltip/hoverEffect.vue"))
const filledTooltip = defineAsyncComponent(() => import("@/components/theme/uikits/tooltip/filledTooltip.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Ui Kits",
      title: "Tooltip"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(basicTooltip)),
        _createVNode(_unref(coloredTooltip)),
        _createVNode(_unref(directionsTooltip)),
        _createVNode(_unref(hoverEffect)),
        _createVNode(_unref(filledTooltip))
      ])
    ])
  ], 64))
}
}

})